import React from "react";

import TableData from "./TableData";
import StackedBarChart from "./chartComponents/StackBarChart";
import ProgressBar from "./chartComponents/ProgressBar";
import UnassignedLead from "./UnassignedLead";
import AdminAppBar from "./AdminAppBar";
import LineChart from "./chartComponents/LineChart";
import { Route, Routes, useNavigate } from "react-router-dom";
import { BsFire } from "react-icons/bs";
import { userRole } from "../Constant/Constant";

const AdminPanel = () => {
  const path = "dashboard";
  console.log(path);
  const navigate = useNavigate();


  const handleHotLead = () =>{
    const path = userRole === "Admin" ? "/admin" : "/cmo"
    navigate(`${path}/hot-lead`)
  }
  return (
    <div className="w-full  bg-appGrayBackground">
      <AdminAppBar />

      <div className=" flex 4xl:mx-36 3xl:mx-28 2xl:mx-32 xl:mx-6 pb-5  custom-xl:mx-24 gap-12 xl:gap-9  custom-xl:gap-10 pt-28  ">
        <div className="grid gap-10 w-1/2 ">
          <LineChart />
          <div className="">
            <StackedBarChart view={path} />
          </div>
        </div>
        <div className=" gap-10 w-1/2 ">
          <TableData />
          {/* <div className="bg-white mt-7 rounded-[10px] p-5">
            <div className="text-xl text-slate-600 font-medium mb-4">Lead Sources</div>
            <div className="flex  items-center gap-4 text-center">
              <div
              onClick={handleHotLead}
              className="bg-white cursor-pointer flex items-center justify-center gap-2 text-base text-[#EE6C4D] font-medium shadow-soft-all w-full rounded-[10px] p-2">
               <BsFire className="text-xl"/> 
               <div>Hot Leads (3)</div>
              </div>
              <div  className="bg-white cursor-pointer text-base font-medium shadow-soft-all text-nowrap w-full p-2 rounded-[10px]">
                CP Management (12)
              </div>
            </div>
          </div> */}
          <div className="mt-7">
            <ProgressBar />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
